import React__default from 'react';
import styled from 'styled-components';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { i as isRtlEnabled } from '../../LocalModules/storm-ui-utils/dist/esm/isRtlEnabled-DXSQ1gyT-C6zs_USs.js';
import { T as Text } from '../../Text/Text-Ce2yOjWM.js';
import { P as PaginationNextButton } from '../../Pagination/PaginationButton/PaginationNextButton-Bx_QERPR.js';
import { P as PaginationPrevButton } from '../../Pagination/PaginationButton/PaginationPrevButton-Dq8e_fFg.js';

const MobilePaginationContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-g66b1t-0"
})(["display:flex;align-items:center;justify-content:end;margin-block-start:", ";gap:", ";width:100%;"], ({
  theme
}) => theme.spacing.xxsmall.mobile, ({
  theme
}) => theme.spacing.small.mobile);
const ButtonContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-g66b1t-1"
})(["display:flex;flex-direction:", ";gap:", ";"], ({
  $reverse
}) => $reverse ? 'row-reverse' : 'reverse', ({
  theme
}) => theme.spacing.xxxsmall.mobile);
const MobilePagination = ({
  canScrollNext,
  canScrollPrev,
  onScrollLeft,
  onScrollRight,
  disabled,
  scrolledToCard = 1,
  cardCount
}) => {
  const {
    formatMessage
  } = useIntl();
  const isRtl = isRtlEnabled();
  const PaginateLeft = isRtl ? PaginationNextButton : PaginationPrevButton;
  const PaginateRight = isRtl ? PaginationPrevButton : PaginationNextButton;
  return /*#__PURE__*/React__default.createElement(MobilePaginationContainer, null, /*#__PURE__*/React__default.createElement(Text, null, formatMessage({
    id: 'mobile_scroll_tracker'
  }, {
    scrolledToCard,
    cardCount
  })), /*#__PURE__*/React__default.createElement(ButtonContainer, {
    $reverse: isRtl
  }, /*#__PURE__*/React__default.createElement(PaginateLeft, {
    id: "mobile-scroll-button-left",
    "data-testid": "mobile-scroll-button-left",
    ariaLabel: formatMessage({
      id: 'previous_scroll_button_label'
    }),
    onClick: onScrollLeft,
    disabled: disabled || !canScrollPrev,
    "aria-disabled": disabled || !canScrollPrev
  }), /*#__PURE__*/React__default.createElement(PaginateRight, {
    id: "mobile-scroll-button-right",
    "data-testid": "mobile-scroll-button-right",
    ariaLabel: formatMessage({
      id: 'next_scroll_button_label'
    }),
    onClick: onScrollRight,
    disabled: disabled || !canScrollNext,
    "aria-disabled": disabled || !canScrollNext
  })));
};

export { MobilePagination as M };
//# sourceMappingURL=MobilePagination-BydrGtmS.js.map
